"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
/**
 * Need do to the opposite? See `strToBin.ts`.
 *
 * Taken from https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/btoa
 *
 * Useful to decode strings with 2-byte unicode chars that have been converted
 * to binary for compatibility with ascii tooling such as btoa().
 */
function binToStr(binary) {
    var bytes = new Uint8Array(binary.length);
    for (var i = 0; i < bytes.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    // TODO: Use ... when TS supports it for Uint16Array
    // see https://github.com/zapier/zapier/pull/39560/commits/f29981a7326a250e1cc738ab65605c9f8a161d46#r414221851
    return lodash_1.spread(String.fromCharCode)(new Uint16Array(bytes.buffer));
}
exports.default = binToStr;
